const datePickerLocale = {
  selectDate: "选择日期",
  now: "现在",
  clear: "清空",
  selectDateRange: "选择日期范围",
  startTime: "开始时间",
  endTime: "结束时间"
};
export {
  datePickerLocale
};
//# sourceMappingURL=zh_CN.js.map
